document.addEventListener('DOMContentLoaded', function () {
    const faqTitles = document.querySelectorAll('.faq-title');

    faqTitles.forEach(function (title) {
        title.addEventListener('click', function () {
            const faqParent = this.closest('.faq-parent');
            const faqMore = faqParent.querySelector('.faq-more');
            const faqMores = document.querySelectorAll('.faq-more');

            faqMores.forEach(function (more) {
                if (more !== faqMore) {
                    more.style.display = 'none';
                }
            });

            faqMore.style.display = faqMore.style.display === 'none' ? 'block' : 'none';

            this.classList.toggle('arrow-rot');

            const serviceImage = document.getElementById('service_image');
            serviceImage.classList.add('trans');

            setTimeout(function () {
                const image = faqParent.dataset.image;
                serviceImage.src = image || serviceImage.dataset.defaultImage;

                setTimeout(function () {
                    serviceImage.classList.remove('trans');
                }, 500);
            }, 500);
        });
    });
});
